import OrderRequest from "../../../../../types/api/order-request"
import { useUpdateOrderRequestMutation } from "../../../../../store/api/order-requests-api"
import { PopconfirmProps } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import { Button, Popconfirm } from "antd"
import useSuccessModal from "../../../../../hooks/api/use-success-modal"
import useErrorModal from "../../../../../hooks/api/use-error-modal"
import { FC } from "react"

interface OrderActionsProps {
    order: OrderRequest
}

const OrderActions: FC<OrderActionsProps> = ({ order }) => {
    const [updateOrderRequest, updateOrderRequestState] = useUpdateOrderRequestMutation()
    const onCancelOrderRequest: PopconfirmProps['onConfirm'] = () => {
        updateOrderRequest({
            docId: order.documentId,
            body: {
                data: {
                    requestStatus: 'Отменен',
                },
            },
        })
    }

    useSuccessModal(updateOrderRequestState, 'Заказ отменен')
    useErrorModal(updateOrderRequestState, 'Ошибка при отмене заказа')


    return (
        <Popconfirm
            title='Отменить заказ'
            description='Вы уверены?'
            onConfirm={onCancelOrderRequest}
            okText='Да'
            cancelText='Нет'
        >
            <Button
                size='small'
                title='Отменить заказ'
                icon={<CloseOutlined />}
                danger
                color='danger'
                variant='solid'
            />
        </Popconfirm>
    )
}

export default OrderActions